/* Milen stage-1-6 info popups (snippets/xz-v2-info-popups.liquid): returns, shipping, warranty, gift.
   Open = his a-51/53/55/57: the wrapper shows, then the content rises 10px and fades in over 500ms
   outQuad (Web Animations, no per-frame style writes). Close = a-52/54/56/58: instant. Added for access:
   Escape, backdrop click, focus trap, focus return to the opener, @theme/dialog scroll lock (page offset
   and sticky elements untouched). The popups move to <body> on first open so no ancestor can clip or
   stack them under the header. A classic script: the scroll lock comes from @theme/dialog through a dynamic
   import, so a browser without import maps (Chrome < 89) still opens and closes the popups, unlocked. */
(function () {
if (window.__xzV2InfoPopup) return;
window.__xzV2InfoPopup = true;
let lock = null;
try { import('@theme/dialog').then((m) => { lock = m; }).catch(() => {}); } catch (e) { /* no dynamic import */ }
const lockScroll = (el) => { if (lock) lock.lockScroll(el); };
const unlockScroll = (el) => { if (lock) lock.unlockScroll(el); };

const OUT_QUAD = 'cubic-bezier(0.3333333, 0.6666667, 0.6666667, 1)';
const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
const reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
let current = null;

function root() {
  return document.querySelector('[data-xz-info-popups]');
}

function open(kind, opener) {
  const popups = root();
  if (!popups) return;
  const wrap = popups.querySelector('[data-xz-info-popup="' + kind + '"]');
  if (!wrap) return;
  if (current) close(false);
  if (popups.parentElement !== document.body) document.body.appendChild(popups);
  const content = wrap.querySelector('.xz-info-popup-content');
  wrap.classList.add('is-open');
  content.scrollTop = 0;
  if (!reduceMotion.matches && content.animate) {
    content.animate(
      [{ opacity: 0, transform: 'translate3d(0, 10px, 0)' }, { opacity: 1, transform: 'translate3d(0, 0, 0)' }],
      { duration: 500, easing: OUT_QUAD }
    );
  }
  lockScroll(wrap);
  current = { wrap, content, opener };
  content.focus({ preventScroll: true });
}

function close(restore = true) {
  if (!current) return;
  const { wrap, content, opener } = current;
  current = null;
  if (content.getAnimations) content.getAnimations().forEach((a) => a.cancel());
  wrap.classList.remove('is-open');
  unlockScroll(wrap);
  if (restore && opener && opener.isConnected) opener.focus({ preventScroll: true });
}

function trap(event) {
  const items = Array.from(current.wrap.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  const active = document.activeElement;
  if (event.shiftKey && (active === first || !current.wrap.contains(active) || active === current.content)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (active === last || !current.wrap.contains(active))) {
    event.preventDefault();
    first.focus();
  }
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest && event.target.closest('[data-xz-info-open]');
  if (opener) {
    open(opener.getAttribute('data-xz-info-open'), opener);
    return;
  }
  if (!current) return;
  if (event.target.closest('[data-xz-info-close]') || event.target === current.wrap) close();
});

document.addEventListener('keydown', (event) => {
  if (event.target.closest?.('[data-kl-scroll-locking-modal]')) return;
  if (current) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'Tab') {
      trap(event);
    }
    return;
  }
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const opener = event.target.closest && event.target.closest('[data-xz-info-open]');
  if (!opener || opener.tagName === 'BUTTON' || opener.tagName === 'A') return;
  event.preventDefault();
  open(opener.getAttribute('data-xz-info-open'), opener);
});

// A bfcache restore must not come back with a popup open and the page locked.
window.addEventListener('pagehide', () => close(false));
})();
